import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import TemplateFactory from "../Templates/TemplateFactory";
import BlogAPIClient from "../../api/clients/blog";
import Loading from "../Components/Loading";

export default function Post() {
  const location = useLocation();
  const params = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [titleArea, setTitleArea] = useState(null);
  const [post, setPost] = useState(null);

  useEffect(() => {
    let allowedToLoad = true;
    // reset post and title area when slug changes
    setPost(null);
    setTitleArea(null);

    // Helper to check for hero module (copied from Page logic)
    const hasHero = (sections) => {
      if (!Array.isArray(sections) || sections.length === 0) return false;
      return sections.some(
        (section) =>
          section &&
          ("hero" === section.section_name ||
            "qip_hero" === section.section_name)
      );
    };

    const loadPost = async () => {
      setIsLoading(true);
      try {
        const API = new BlogAPIClient();
        const response = await API.getPost(params.slug);

        // WordPress API returns an array for slug lookups, take the first item
        const postData = response && response?.post ? response.post : null;

        if (postData) {
          setPost(postData);

          // Use sections if they exist, otherwise default to empty array
          const _sections = postData.sections || [];

          // Only set title area if NO hero module is present in the custom sections
          if (!hasHero(_sections)) {
            setTitleArea({
              title: postData.title?.rendered || postData.title || null,
              image: postData.featured_image?.large
                ? postData.featured_image.large[0]
                : null,
              breadcrumbs: [
                {
                  title: "Blog",
                  url: "/blog",
                },
              ],
            });
          } else {
            setTitleArea(null);
          }
        }
      } catch (err) {
        console.error(err);
        setTitleArea(null);
      }
      setIsLoading(false);
    };

    // when safe to load
    if (location.pathname !== "/_error" && allowedToLoad) {
      loadPost();
    }

    return () => {
      allowedToLoad = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.slug]);

  if (isLoading && !post) return <Loading inclIcon={true} />;
  if (!post) return null;

  return (
    <TemplateFactory
      template={post.template || "post-template"}
      title={titleArea}
      content={post.content?.rendered || post.content}
      modules={post.sections}
      sidebarModules={post.sidebar}
      footerModules={post.footer}
    />
  );
}
